import { render, staticRenderFns } from "./AddEditExamDemo.vue?vue&type=template&id=0d490c75&scoped=true"
import script from "./AddEditExamDemo.vue?vue&type=script&lang=js"
export * from "./AddEditExamDemo.vue?vue&type=script&lang=js"
import style0 from "./AddEditExamDemo.vue?vue&type=style&index=0&id=0d490c75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d490c75",
  null
  
)

export default component.exports